import { defineStore } from "pinia";
import SETTINGS_QUERY from "./settings.graphql";

export const useSettingsStore = defineStore("settings", {
  state: () => ({
    settings: {},
  }),
  getters: {
    isZoneOnly() {
      return this.settings.zone_only === "true";
    },
    countryCenterCoords() {
      const coords = this.settings.country_center_coords;
      return coords ? JSON.parse(coords) : [0, 0];
    },
    supportPhoneVisible() {
      return this.settings.support_phone_visible === "true";
    },
    hotLinePhoneVisible() {
      return this.settings.hotline_alive === "true";
    },
    hotLinePhoneNumber() {
      return this.settings.hotline_phone_number;
    },
    hotLineHours() {
      return this.settings.hotline_hours;
    },
    showTenderDate() {
      return this.settings.showTenderDate === "true";
    },
    taxNumberMask() {
      return this.settings.taxNumberMask ?? "";
    },
    taxNumberBelongsToGroupRegex() {
      const regexString = this.settings.taxNumberBelongsToGroupRegex;

      if (!regexString) {
        return null;
      }

      return new RegExp(regexString);
    },
    taxGroupNumberMask() {
      return this.settings.taxGroupNumberMask ?? "";
    },
    vatOptions() {
      if (!this.settings?.vatOptions) {
        return [];
      }

      try {
        return JSON.parse(this.settings.vatOptions);
      } catch (err) {
        console.error(err);
        this.$nuxt.$logger.error("Failed to parse vatOptions", err);
        return [];
      }
    },
    capitalCityId() {
      return Number(this.settings.capitalCityId);
    },
    contactForm() {
      return this.settings?.contactForm ?? null;
    },
    paymentLink() {
      return this.settings?.paymentLink ?? null;
    },
    zoneAreaOptions() {
      if (!this.settings?.zoneAreaOptions) {
        return [];
      }

      try {
        return JSON.parse(this.settings.zoneAreaOptions);
      } catch (err) {
        console.error(err);
        this.$nuxt.$logger.error("Failed to parse zoneAreaOptions", err);
        return [];
      }
    },
    getSettings() {
      return this.settings;
    },
  },
  actions: {
    async loadSettings() {
      try {
        const result = await this.$nuxt.$query(SETTINGS_QUERY);
        this.settings = result.settings.reduce((accumulator, currentValue) => {
          accumulator[currentValue.name] = currentValue.value;
          return accumulator;
        }, {});
      } catch (err) {
        console.error(err);
        this.$nuxt.$logger.error("Failed to load settings", err);
      }
    },
  },
});
